import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

export default function Logo({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 523.5 107.6"
      xmlSpace="preserve"
      className={mergeClasses('', className)}
    >
      <g>
        <path
          className="fill-[#231F20]"
          d="M130.7,58.4V25.6h15.1v31.8c0,9,4,13.8,12.2,13.8c8.2,0,12.2-4.8,12.2-13.8V25.6h15.1v32.9
        c0,18.2-11.2,27.4-27.4,27.4C141.7,85.8,130.7,76.4,130.7,58.4z M191.6,25.6h15.1v6.6c3.8-5.5,9.5-8.3,17.5-8.3
        c13.4,0,22.1,10.1,22.1,25.6v34.7h-15.1V52.3c0-9-4-13.8-11.6-13.8c-9.4,0-12.8,6-12.8,16.2v29.4h-15.1L191.6,25.6L191.6,25.6z
         M251.1,9.2c0-5,4-9.2,9.2-9.2c5.3,0,9.2,4.2,9.2,9.2s-4,9.2-9.2,9.2C255.1,18.5,251.1,14.3,251.1,9.2z M252.8,25.6h15.1v58.6
        h-15.1V25.6z M272.6,75.5l10-9.5c3.6,3.5,8.2,6.4,13.7,6.4c4.3,0,7.4-1.9,7.4-5.2c0-3.4-2.8-4.7-9.8-6.6
        c-8.6-2.3-19.6-5.9-19.6-18.6c0-11.8,10.7-18.4,21.4-18.4c9.7,0,16.6,3.5,21.8,9.1l-10,9.5c-3.7-3.2-7.1-4.9-11.6-4.9
        c-3.8,0-6.5,2-6.5,4.7c0,3.4,3.1,4.6,11,6.6c9.6,2.5,18.5,7.1,18.4,18.5c-0.1,12.7-10.3,19-21.7,19C286.3,86,278.1,82.1,272.6,75.5
        z M323.9,25.6h15v6.6c4.3-5.3,10.8-8.3,19.2-8.3c16.7,0,27.5,13.4,27.5,31s-12.5,31-28,31c-8.4,0-14.4-3-18.7-7.6v29.4h-15
        L323.9,25.6L323.9,25.6z M370.2,54.8c0-9.1-5.9-16.3-15.6-16.3s-15.7,7.2-15.7,16.3c0,9.1,6,16.3,15.7,16.3S370.2,64,370.2,54.8z
         M389.6,54.8c0-17.5,12.5-31,31-31s31,13.4,31,31s-12.5,31-31,31S389.6,72.4,389.6,54.8z M436.2,54.8c0-9.1-5.9-16.3-15.6-16.3
        S405,45.7,405,54.8c0,9.1,5.9,16.3,15.6,16.3S436.2,64,436.2,54.8z M456,25.6h15v10.1c2.6-7.9,7.7-10.1,13.6-10.1h1.9V40h-2.4
        c-9.7,0-13.1,5.3-13.1,17.9v26.3h-15L456,25.6L456,25.6z M496.9,67.2V40h-6.8V25.6h6.8V17l14.6-7.7v16.2h12V40h-12v23.8
        c0,5.6,1.4,6,7.3,6h4.7v14.4h-8.4C501.7,84.1,496.9,78.4,496.9,67.2z"
        />
        <g>
          <polygon
            className="fill-[#0CD428]"
            points="0,70.4 0,0 35.1,0 35.1,88.7"
          />
          <polygon
            className="fill-[#0CD428]"
            points="40.5,91.5 65.3,67.8 65.3,0 100.4,0 100.4,80.2 71.6,107.6"
          />
        </g>
      </g>
    </svg>
  );
}

Logo.propTypes = {
  className: PropTypes.string
};

Logo.defaultProps = {
  className: ''
};
